import React from 'react';

export default function MinimalInput({
  label,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  name,
  disabled = false,
  autoComplete = 'off',
  ...props
}) {
  return (
    <div className="flex flex-col w-full mb-6">
      {label && (
        <label className="text-xs text-gray-500 mb-1" htmlFor={name}>
          {label}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        className={`bg-transparent border-0 border-b border-gray-300 focus:border-gray-800 focus:ring-0 transition-colors text-base px-0 py-2 outline-none ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : ''
        } ${props.className || ''}`}
        {...props}
      />
    </div>
  );
}
